import fetch from 'isomorphic-fetch'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: 'https://docs.fs.illinois.edu/graphql',
    fetch,
    credentials: 'same-origin',
    headers: {},
  }),
})

export default client
